export default __webpack_public_path__ + "static/media/floodio.70c93ccf.svg";